import React from 'react';
import './TargetClients.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const TargetClients = () => {
  const sectionRef = useScrollAnimation();
  const clientTypes = [
    {
      icon: '🏢',
      title: 'Small to medium-sized companies in Greater Toronto Area',
      description: 'Comprehensive accounting solutions tailored for GTA businesses'
    },
    {
      icon: '🤝',
      title: 'Non-profit organizations',
      description: 'Specialized accounting services for charitable organizations'
    },
    {
      icon: '👤',
      title: 'Individuals needing personal financial record-keeping',
      description: 'Personal tax preparation and financial planning services'
    },
    {
      icon: '🚀',
      title: 'New companies wanting proper setup from start',
      description: 'Complete business incorporation and setup services'
    },
    {
      icon: '⏰',
      title: 'Business owners spending too much time on bookkeeping',
      description: 'Professional bookkeeping to free up your valuable time'
    },
    {
      icon: '📊',
      title: 'Companies with mismanaged financial records',
      description: 'Expert cleanup and organization of financial records'
    },
    {
      icon: '💰',
      title: 'Businesses overpaying for full-time bookkeepers',
      description: 'Cost-effective accounting solutions for your business'
    }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="target-clients section fade-in-right" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services Are Ideal For</h2>
          <p className="section-subtitle">We serve a diverse range of clients across the Greater Toronto Area</p>
        </div>

        <div className="clients-grid">
          {clientTypes.map((client, index) => (
            <div key={index} className="client-card">
              <div className="client-icon">{client.icon}</div>
              <h3 className="client-title">{client.title}</h3>
              <p className="client-description">{client.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TargetClients;
